<div class="maint-container">
  <div class="cle-main">
    <app-site-header headerText='CLE Sponsor Portal'></app-site-header>
  </div>
  <div class="maint-content" style="margin-top: 20px;">
    <span class="maint-text">The CLE Sponsor Portal is currently unavailable for maintenance.   We apologize for the inconvenience.  If you have questions, please call the CLE Department at 404-527-8710.</span>
  </div>
</div>
